module.exports = __webpack_public_path__ + "img/pencil-icon.3b694e52.svg";